import * as _4 from 'lodash4';
import { APGenericSlot } from '../../../global/builders/ap_generic_slot_builder';
import { IAPAPMarkAsMetStatusDatasource } from '../../../global/components/mark_as_met/datasources/mark_as_met_status_datasource';
import { APSlotStatusBadgeHtmlServant } from './servants/slot_status_badge_html_servant';

class SlotStatusBadge {
  private genericSlot: APGenericSlot;
  private slotBadgesHtml: string[] = [];

  constructor(
    private ngAPMarkAsMetStatusDatasource: IAPAPMarkAsMetStatusDatasource,
    private ngAPSlotStatusBadgeHtmlServant: APSlotStatusBadgeHtmlServant
  ) {}

  $onChanges() {
    if (this.genericSlot) {
      this.slotBadgesHtml = this.ngAPSlotStatusBadgeHtmlServant.getBadges(this.genericSlot);
    }
  }
}

angular.module('capability-ng-academic-planner').component('slotStatusBadge', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/slot_status_badge/slot_status_badge.html',
  bindings: {
    genericSlot: '<'
  },
  controller: SlotStatusBadge
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/slot_status_badge/slot_status_badge.ts